import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { height, width } from '@mui/system';
import getWindowDimensions from '../../../utils/getHeightWidth';  

const CustomModal = (props) => {
  const { width } = getWindowDimensions();
  const defaultWidth = width >= 992 ? "50% !important" : "90% !important";
  const style = {
    height: "auto",
    maxHeight: `${props.maxHeight ? props.maxHeight : "90%"}`,
    minHeight: `${props.height ? props.height : "auto"}`,
    overflow: "auto",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: `${props.width ? props.width + "!important" : defaultWidth}`,
    bgcolor: props.bgcolor ? props.bgcolor : "background.paper",
    boxShadow: 24,
    padding: `${props.padding ? props.padding : '1.3rem !important'}`,
    outline: "none",
    ...props.customStyles, 
  };

  return (
    <>
      <Modal open={props.open} onClose={props.handleClose} disableEscapeKeyDown={false} >
        <Box sx={style} className={`rounded w-auto ${props.customHeight ? props.customHeight : ""}`}>
          {props.children}
        </Box>
      </Modal>
    </>
  );
};

export default CustomModal;
